export default __webpack_public_path__ + "static/media/basic-account-bg.767b891a.png";